const sharedSrcSet = ['(min-width: 1360px) 1360px', 'calc(100vw - 24px)'].join(
	', ',
);

export const imageSizes = {
	'50-50-media-bottom-media-left': sharedSrcSet,
	'50-50-media-bottom-media-right': sharedSrcSet,
	'50-50-media-top-media-left': sharedSrcSet,
	'50-50-media-top-media-right': sharedSrcSet,
	'50-50-stretch': [
		'(min-width: 790px) 375px',
		'(min-width: 768px) calc(50vw - 24px)',
		'calc(100vw - 24px)',
	].join(', '),
	'50-50-wide': [
		'(min-width: 1360px) 680px',
		'(min-width: 790px) 375px',
		'(min-width: 768px) calc(50vw - 24px)',
		'calc(100vw - 24px)',
	].join(', '),
	carousel: [
		'(min-width: 1400px) 322px',
		'(min-width: 1024px) calc(25vw - 96px)',
		'(min-width: 768px) calc(33vw - 72px)',
		'calc(80vw - 36px)',
	].join(', '),
	'carousel-tiles': [
		'(min-width: 1024px) calc(33vw - 48px)',
		'(min-width: 768px) calc(50vw - 48px)',
		'calc(80vw - 24px)',
	].join(', '),
	'category-card': ['(min-width: 768px) 200px', '223px'].join(', '),
	'content-card': ['(min-width: 768px) 202px', '230px'].join(', '),
	'full-bleed-media': '100vw',
	gridwall: [
		'(min-width: 1400px) 325px',
		'(min-width: 768px) calc(25vw - 84px)',
		'calc(50vw - 36px)',
	].join(', '),
	'hero-carousel': ['100vw'].join(', '),
	list: ['(min-width: 768px) 206px', '72px'].join(', '),
	'list-horizontal': '206px',
	'list-media-large': ['(min-width: 768px) 206px', '72px'].join(', '),
	'list-media-left': '206px',
	'list-media-right': '206px',
	'list-media-small': '72px',
	overlay: [
		'(min-width: 1600px) 494px',
		'(min-width: 768px) calc(33vw - 60px)',
		'calc(71vw - 60px)',
	].join(', '),
	'overlay-hero': ['(min-width: 1520px) 1520px', '100vw'].join(', '),
	poster: [
		'(min-width: 1024px) calc(25vw - 72px)',
		'(min-width: 768px) calc(33vw - 72px)',
		'calc(50vw - 36px)',
	].join(', '),
	'posts-collage': [
		'(min-width: 768px) calc(25vw - 96px)',
		'calc(50vw - 32px)',
	].join(', '),
	stacked: [
		'(min-width: 670px) 670px',
		'(min-width: 352px): 352px',
		'(min-width: 322px): 322px',
		'170px',
	].join(', '),
	'stacked-large': sharedSrcSet,
	standard: [
		'(min-width: 938px) calc(25vw - 72px)',
		'(min-width: 768px) calc(25vw - 120px)',
		'calc(50vw - 36px)',
	].join(', '),
} as const;
